import React, { useState } from 'react';

//@ts-ignore
import * as styles from './filtered-content.module.css';
//@ts-ignoree
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { ContentPreview } from './index';
import { getMediaData } from '../Global/DataUtils';
import { Publication } from '../Global/DataUtils/publicationQueries';
import { KontentStringValue } from '../../../types/KontentProps';
import RichText from '../Global/RichText';
import CtaLink from '../Global/CtaLink';
import ArrowLgButton from '../Global/ArrowLgButton';

interface Props {
    content?: ContentPreview[];
    cta_label?: KontentStringValue;
    centerItemPlacement: number;
    center_item?: Publication;
    featured_tiles?: Publication[];
}

const NewsMediaExploration: React.FC<Props> = ({
    content,
    cta_label,
    centerItemPlacement,
    center_item,
    featured_tiles,
}) => {
    let tiles: ContentPreview[] =
        featured_tiles != undefined ? featured_tiles : [];
    const backfillContent = 3 - tiles.length;
    let slicedContent =
        content != undefined ? content?.slice(0, backfillContent) : [];
    tiles = [...tiles, ...slicedContent];

    const carouselContent = tiles.slice(0, 3);
    const additionalContent = content?.slice(backfillContent);
    const breakpoints = useBreakpoint();

    let contentTitles = content?.map((item) => item.elements.title);

    const [currentMobileItem, setCurrentMobileItem] = useState(0);
    const arrowStrokeColor = '#f06623';

    const handlePrevClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        const newItem = currentMobileItem - 1;

        setCurrentMobileItem(newItem);
    };

    const handleNextClick = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        const newItem = currentMobileItem + 1;

        setCurrentMobileItem(newItem);
    };

    const renderCarouselCard = (
        contentItem: Publication,
        contentIdx: number
    ) => {
        if (breakpoints.md || contentIdx === currentMobileItem) {
            const contentElements = contentItem.elements;
            const image = getMediaData(contentElements.image);
            return (
                <div key={contentIdx} className={styles.newsCarouselCard}>
                    {image?.url && (
                        <div className={styles.image}>
                            <picture>
                                <img
                                    src={image?.url}
                                    alt={image?.description || image?.name}
                                />
                            </picture>
                        </div>
                    )}

                    <div className={styles.newsBody}>
                        <div className={styles.newsTitle}>
                            {contentElements.title.value}
                        </div>
                        <div className={styles.newsSource}>
                            {contentElements.source.value}
                        </div>
                    </div>

                    {contentElements.url_location.value && (
                        <div className={styles.newsCtaContainer}>
                            <CtaLink
                                href={contentElements.url_location.value}
                                target="_new"
                            >
                                {cta_label?.value}
                            </CtaLink>
                        </div>
                    )}

                    {!contentElements.url_location.value &&
                        contentElements.document.value[0] && (
                            <div className={styles.newsCtaContainer}>
                                <CtaLink
                                    href={
                                        contentElements.document.value[0]
                                            .elements.document.value[0]?.url
                                    }
                                    target="_new"
                                >
                                    {cta_label?.value}
                                </CtaLink>
                            </div>
                        )}
                </div>
            );
        }
    };

    const renderCenterContent = () => {
        const contentElements = center_item?.elements;
        const image = getMediaData(contentElements?.image);

        if (!contentElements) {
            return null;
        }

        return (
            <div className={styles.newsCenterCard}>
                {image?.url && (
                    <div className={styles.image}>
                        <picture>
                            <img
                                src={image?.url}
                                alt={image?.description || image?.name}
                            />
                        </picture>
                    </div>
                )}

                <div className={styles.newsCenterBody}>
                    <div>
                        <div className={styles.newsSource}>
                            {contentElements.source.value}
                            {contentElements.publication_date.value && ` | `}
                            {contentElements.publication_date.value}
                        </div>
                        <div className={styles.newsTitle}>
                            {contentElements.title.value}
                        </div>
                    </div>
                    <div className={styles.summary}>
                        {RichText(contentElements.short_description)}
                    </div>
                    {contentElements.url_location.value && (
                        <div className={styles.newsCtaContainer}>
                            <CtaLink
                                href={contentElements.url_location.value}
                                target="_new"
                            >
                                {cta_label?.value}
                            </CtaLink>
                        </div>
                    )}

                    {!contentElements.url_location.value &&
                        contentElements.document.value[0] && (
                            <div className={styles.newsCtaContainer}>
                                <CtaLink
                                    href={
                                        contentElements.document.value[0]
                                            .elements.document.value[0]?.url
                                    }
                                    target="_new"
                                >
                                    {cta_label?.value}
                                </CtaLink>
                            </div>
                        )}
                </div>
            </div>
        );
    };

    const renderRow = (contentItem: Publication, contentIdx: number) => {
        const contentElements = contentItem.elements;
        const logo = getMediaData(contentItem.elements.publication_logo);

        return (
            <React.Fragment key={contentIdx}>
                {centerItemPlacement === contentIdx && renderCenterContent()}

                <a
                    href={
                        contentElements.url_location.value ||
                        contentElements.document?.value[0]?.elements?.document
                            .value[0]?.url
                    }
                    target="_new"
                    className={styles.newsRow}
                >
                    {logo?.url && (
                        <picture>
                            <img
                                className={styles.logo}
                                src={logo.url}
                                alt={logo.description || logo.name}
                            />
                        </picture>
                    )}
                    <div className={styles.newsRowBody}>
                        <div className={styles.newsRowTitle}>
                            {contentElements.title.value}
                        </div>
                        <div className={styles.newsSource}>
                            {contentElements.source?.value}
                            {contentElements.publication_date.value && ` | `}
                            {contentElements.publication_date.value}
                        </div>
                    </div>
                </a>
            </React.Fragment>
        );
    };

    return (
        <div className={styles.newsExploration}>
            {carouselContent && (
                <div className={styles.newsCarouselContainer}>
                    {currentMobileItem != 0 && !breakpoints.md ? (
                        <ArrowLgButton
                            direction="left"
                            strokeColor={arrowStrokeColor}
                            handleClick={handlePrevClick}
                            className={styles.carouselPrev}
                        />
                    ) : null}
                    <div className={styles.newsCarousel}>
                        {carouselContent.map((contentItem, itemIdx) => {
                            return renderCarouselCard(
                                contentItem as Publication,
                                itemIdx
                            );
                        })}
                    </div>
                    {currentMobileItem != carouselContent?.length - 1 &&
                    !breakpoints.md ? (
                        <ArrowLgButton
                            direction="right"
                            strokeColor={arrowStrokeColor}
                            handleClick={handleNextClick}
                            className={styles.carouselNext}
                        />
                    ) : null}
                    {!breakpoints.md && (
                        <div className={styles.dots}>
                            {renderDots(
                                carouselContent?.length,
                                currentMobileItem
                            )}
                        </div>
                    )}
                </div>
            )}
            {additionalContent && (
                <div className={styles.newsRows}>
                    {additionalContent.map((contentItem, itemIdx) => {
                        return renderRow(contentItem as Publication, itemIdx);
                    })}
                </div>
            )}
        </div>
    );
};

export default NewsMediaExploration;

function renderDots(dotsToShow: number, currentPosition: number) {
    let dots = [];

    for (let i = 0; i < dotsToShow; i++) {
        dots.push(
            <span
                key={i}
                style={currentPosition == i ? { background: '#ccc' } : {}}
            ></span>
        );
    }

    return dots;
}
